




(function($){ $(function(){
    
    
    
    
        $('a#featuredProductsLink').click(function(){    
            $('#bestSellersList').hide();
            $(this).addClass('featuredProductsActive');
            $('#bestSellersLink').removeClass('featuredProductsActive');
            $('#featuredProductsList').fadeIn('slow');
            return false;
        });
        $('a#bestSellersLink').click(function(){
            $('#featuredProductsList').hide();
            $(this).addClass('featuredProductsActive');
            $('#featuredProductsLink').removeClass('featuredProductsActive');
            $('#bestSellersList').fadeIn('slow');
            return false;
        });
        

}); })(jQuery)